import { render, staticRenderFns } from "./PermissionsRequest.vue?vue&type=template&id=eb9286f4&scoped=true"
import script from "./PermissionsRequest.vue?vue&type=script&lang=js"
export * from "./PermissionsRequest.vue?vue&type=script&lang=js"
import style0 from "./PermissionsRequest.vue?vue&type=style&index=0&id=eb9286f4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb9286f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eb9286f4')) {
      api.createRecord('eb9286f4', component.options)
    } else {
      api.reload('eb9286f4', component.options)
    }
    module.hot.accept("./PermissionsRequest.vue?vue&type=template&id=eb9286f4&scoped=true", function () {
      api.rerender('eb9286f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/PermissionsRequest.vue"
export default component.exports